function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOnboardingCardBackground = function SvgOnboardingCardBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 154,
    viewBox: "0 0 345 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.483-16.762c24.51-85.079 140.472-103.123 187.783-96.392 106.6 15.166 220.081 198.456 59.659 208.767-160.422 10.311-119.619 74.414-200.013 53.593-80.395-20.821-71.938-80.89-47.429-165.968z",
    fill: props.accentFill
  }));
};
export default SvgOnboardingCardBackground;